import styles from "./Label.module.css";

const Label = ({
   label,
   value,
   unit,
   showBorder,
}: {
   label: string;
   value: string;
   unit?: string;
   showBorder?: boolean;
}) => {
   return (
      <div className={`${styles.wrap} ${showBorder ? styles.border : ""}`}>
         <div className={styles.label}>{label}</div>
         <div className={`${styles.value} number`}>
            {value} {unit}
         </div>
      </div>
   );
};

export default Label;
